import useAsyncData from "../../../../hooks/use-async-data";
import orderService from "../../order.service";
import OrderCargoOrderNodeExclusion from "./order-cargo-order-node-exclusion";
import OrderCargoOrderNodeExclusionParams from "./order-cargo-order-node-exclusion-params";

const useOrderCargoOrderNodeExclusion = () => {
  const { data, isError, isLoading, setData, setIsError, setIsLoading } =
    useAsyncData<OrderCargoOrderNodeExclusion | null>(null);

  const load = async (
    params: OrderCargoOrderNodeExclusionParams,
    abortSignal: AbortSignal,
  ) => {
    setIsError(false);
    setIsLoading(true);

    try {
      const data = await orderService.getNodeExclusion(params, abortSignal);

      setData(data);
    } catch {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    data,
    isError,
    isLoading,
    load,
  };
};

export default useOrderCargoOrderNodeExclusion;
